import React from 'react';
import { useCategory } from '../../context/CategoryContext.tsx';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip,
  Tab,
  Tabs,
} from '@mui/material';
import { } from '@mui/icons-material';
import { motion } from 'framer-motion';

interface Product {
  id: number;
  name: string;
  price: string;
  originalPrice?: string;
  image: string;
  category: string;
  rating: number;
  reviews: number;
  features: string[];
  isNew?: boolean;
  isSale?: boolean;
}

const Products: React.FC = () => {
  const { selectedCategory, setSelectedCategory } = useCategory();
  const [showAll, setShowAll] = React.useState(false);


  const categories = [
    { name: 'All', icon: '🛋️' },
    { name: 'Sofas', icon: '🛋️' },
    { name: 'Beds', icon: '🛏️' },
    { name: 'Recliners', icon: '💺' },
    { name: 'Chairs', icon: '🪑' },
    { name: 'Wall Padding', icon: '🧱' },
  ];

  const products: Product[] = [
    // Sofas
    { id: 1, name: 'Elite L-Shape Sofa', price: '', originalPrice: '', image: '/images/furniture/Elite L-shape sofa.png', category: 'Sofas', rating: 4.9, reviews: 145, features: ['L-Shape', 'Premium Fabric', 'Customizable'], isNew: true, isSale: true },
    { id: 2, name: 'Luxury U-Type Sofa', price: '', originalPrice: '', image: '/images/furniture/Luxury U-type sofa.jpeg', category: 'Sofas', rating: 4.8, reviews: 132, features: ['U-Shape', 'Spacious', 'Premium Quality'], isSale: true },
    { id: 3, name: 'Elite Sofa', price: '', originalPrice: '', image: '/images/furniture/Elite sofa.jpeg', category: 'Sofas', rating: 4.7, reviews: 98, features: ['3-Seater', 'Elegant Design', 'Comfortable'], isSale: true },
    { id: 4, name: 'Luxe Tufted Sofa', price: '', originalPrice: '', image: '/images/furniture/Luxe tuft sofa.jpeg', category: 'Sofas', rating: 4.9, reviews: 156, features: ['Hand-Tufted', 'Premium Velvet', 'Luxury'], isNew: true, isSale: true },
    { id: 11, name: 'Classic Line Sofa', price: '', originalPrice: '', image: '/images/furniture/Classic line sofa.jpeg', category: 'Sofas', rating: 4.8, reviews: 95, features: ['Classic', 'Timeless', 'Elegant'], isSale: true },
    { id: 12, name: 'Contemporary Sofa Set', price: '', originalPrice: '', image: '/images/furniture/Contemporary sofa set.jpeg', category: 'Sofas', rating: 4.7, reviews: 88, features: ['Contemporary', 'Modern', 'Stylish'], isSale: true },
    { id: 13, name: 'L-Shaped Sofa', price: '', originalPrice: '', image: '/images/furniture/L-shaped sofa.jpeg', category: 'Sofas', rating: 4.8, reviews: 102, features: ['L-Shape', 'Spacious', 'Comfortable'], isSale: true },
    { id: 14, name: 'Lounge Couch', price: '', originalPrice: '', image: '/images/furniture/lounge couch .jpeg', category: 'Sofas', rating: 4.6, reviews: 79, features: ['Lounge', 'Relaxing', 'Modern'], isSale: true },
    { id: 15, name: 'Modern L Sofa', price: '', originalPrice: '', image: '/images/furniture/modern L sofa.jpeg', category: 'Sofas', rating: 4.7, reviews: 91, features: ['Modern', 'L-Shape', 'Sleek'], isSale: true },
    { id: 16, name: 'Modern Sofa Set', price: '', originalPrice: '', image: '/images/furniture/Modern sofa set.jpeg', category: 'Sofas', rating: 4.8, reviews: 105, features: ['Modern', 'Complete Set', 'Stylish'], isSale: true },
    { id: 17, name: 'Premium L Shape', price: '', originalPrice: '', image: '/images/furniture/Premium L shape.jpeg', category: 'Sofas', rating: 4.9, reviews: 118, features: ['Premium', 'L-Shape', 'Luxury'], isNew: true, isSale: true },
    { id: 18, name: 'Urban Sofa Set', price: '', originalPrice: '', image: '/images/furniture/Urban sofa set.jpeg', category: 'Sofas', rating: 4.7, reviews: 93, features: ['Urban', 'Modern', 'Compact'], isSale: true },
    { id: 19, name: 'Urban Wood Sofa', price: '', originalPrice: '', image: '/images/furniture/urban wood sofa.jpeg', category: 'Sofas', rating: 4.8, reviews: 97, features: ['Wood Frame', 'Urban', 'Durable'], isSale: true },
    { id: 20, name: 'Wooden Luxe Sofa', price: '', originalPrice: '', image: '/images/furniture/wooden luxe sofa.jpeg', category: 'Sofas', rating: 4.9, reviews: 125, features: ['Wooden', 'Luxury', 'Premium'], isNew: true, isSale: true },
    { id: 37, name: 'Nova Luxury Sofa', price: '', originalPrice: '', image: '/images/furniture/Nova luxury sofa.png', category: 'Sofas', rating: 4.8, reviews: 64, features: ['Premium Comfort', 'Luxury Finish', 'Customizable'], isNew: true, isSale: true },
    { id: 5, name: 'Modern Fabric Sofa', price: '', originalPrice: '', image: '/images/furniture/Modern fabric sofa.jpeg', category: 'Sofas', rating: 4.6, reviews: 87, features: ['Modern Design', 'Soft Fabric', 'Durable'], isSale: true },
    { id: 6, name: 'Royal Sofa Set', price: '', originalPrice: '', image: '/images/furniture/royal sofa set.jpeg', category: 'Sofas', rating: 4.8, reviews: 112, features: ['Complete Set', 'Royal Design', 'Premium'], isSale: true },
    { id: 7, name: 'Urban Sectional Sofa', price: '', originalPrice: '', image: '/images/furniture/Urban Sectional sofa.jpeg', category: 'Sofas', rating: 4.7, reviews: 94, features: ['Sectional', 'Urban Style', 'Spacious'], isSale: true },
    { id: 8, name: 'Curved Sofa Set', price: '', originalPrice: '', image: '/images/furniture/Curved sofa set.jpeg', category: 'Sofas', rating: 4.8, reviews: 103, features: ['Curved Design', 'Unique', 'Elegant'], isNew: true, isSale: true },
    { id: 9, name: 'Ottoman Sectional Sofa', price: '', originalPrice: '', image: '/images/furniture/Ottoman sectional sofa.jpeg', category: 'Sofas', rating: 4.6, reviews: 76, features: ['With Ottoman', 'Sectional', 'Comfortable'], isSale: true },
    { id: 10, name: 'Tuxedo Sofa', price: '', originalPrice: '', image: '/images/furniture/Tuxedo sofa.jpeg', category: 'Sofas', rating: 4.7, reviews: 89, features: ['Classic Style', 'Elegant', 'Premium'], isSale: true },
    // Beds
    { id: 21, name: 'Designer Panel Bed', price: '', originalPrice: '', image: '/images/furniture/Designer panel bed.jpeg', category: 'Beds', rating: 4.9, reviews: 134, features: ['Panel Design', 'King Size', 'Premium Wood'], isNew: true, isSale: true },
    { id: 22, name: 'Elite Bed', price: '', originalPrice: '', image: '/images/furniture/Elite bed.jpeg', category: 'Beds', rating: 4.8, reviews: 121, features: ['Luxury Design', 'Storage', 'Comfortable'], isSale: true },
    { id: 23, name: 'Luxury Upholstered Bed', price: '', originalPrice: '', image: '/images/furniture/Luxury upholstered bed.jpeg', category: 'Beds', rating: 4.9, reviews: 145, features: ['Upholstered', 'Premium Fabric', 'Elegant'], isNew: true, isSale: true },
    { id: 24, name: 'Upholstered Platform Bed', price: '', originalPrice: '', image: '/images/furniture/Upholstered platfrom bed.png', category: 'Beds', rating: 4.7, reviews: 98, features: ['Platform', 'Modern', 'Sturdy'], isSale: true },
    { id: 38, name: 'Haven Panel Bed', price: '', originalPrice: '', image: '/images/furniture/Haven panel Bed.jpg', category: 'Beds', rating: 4.6, reviews: 42, features: ['Panel Headboard', 'King Size', 'Sturdy'], isNew: true, isSale: false },
    { id: 39, name: 'Imperial Comfort Bed', price: '', originalPrice: '', image: '/images/furniture/Imperial-comfort Bed.png', category: 'Beds', rating: 4.7, reviews: 57, features: ['Comfort Design', 'Storage Option', 'Premium Finish'], isNew: true, isSale: false },
    { id: 40, name: 'Luxury Bed', price: '', originalPrice: '', image: '/images/furniture/Luxury Bed.jpg', category: 'Beds', rating: 4.8, reviews: 68, features: ['Luxurious Upholstery', 'Comfort Foam', 'Elegant'], isNew: true, isSale: false },
    { id: 41, name: 'Milano Soft Bed', price: '', originalPrice: '', image: '/images/furniture/Milano soft Bed.jpg', category: 'Beds', rating: 4.6, reviews: 38, features: ['Soft Upholstery', 'Modern Look', 'Durable Frame'], isNew: true, isSale: false },
    { id: 42, name: 'Opulence Master Bed', price: '', originalPrice: '', image: '/images/furniture/Opulence master Bed.jpg', category: 'Beds', rating: 4.9, reviews: 74, features: ['Master Design', 'Premium Materials', 'Spacious'], isNew: true, isSale: true },
    { id: 43, name: 'Urban Platform Bed', price: '', originalPrice: '', image: '/images/furniture/Urban platform Bed.jpg', category: 'Beds', rating: 4.5, reviews: 29, features: ['Platform Base', 'Urban Style', 'Low Profile'], isNew: true, isSale: false },
    { id: 66, name: 'Celeste Contemporary Bed', price: '', originalPrice: '', image: '/images/furniture/Celeste contemporary Bed.jpg', category: 'Beds', rating: 4.8, reviews: 55, features: ['Contemporary Design', 'Modern Style', 'Elegant'], isNew: true, isSale: false },
    { id: 68, name: 'Furniture Bed', price: '', originalPrice: '', image: '/images/furniture/Furniture bed.webp', category: 'Beds', rating: 4.7, reviews: 43, features: ['Stylish Design', 'Durable', 'Modern'], isNew: true, isSale: false },

    // Recliners
    { id: 25, name: 'Elite Comfort Recliner', price: '', originalPrice: '', image: '/images/furniture/Elite confort Recliner.jpeg', category: 'Recliners', rating: 4.9, reviews: 167, features: ['Power Recline', 'Massage', 'Premium'], isNew: true, isSale: true },
    { id: 26, name: 'Luxury Recliner', price: '', originalPrice: '', image: '/images/furniture/Luxury Recliner.jpeg', category: 'Recliners', rating: 4.8, reviews: 143, features: ['Luxury Design', 'Comfortable', 'Adjustable'], isSale: true },
    { id: 27, name: 'Motorized Recliner', price: '', originalPrice: '', image: '/images/furniture/Motorized Recliner .jpeg', category: 'Recliners', rating: 4.9, reviews: 189, features: ['Motorized', 'Remote Control', 'Premium'], isNew: true, isSale: true },
    { id: 28, name: 'Lux L-Recliner', price: '', originalPrice: '', image: '/images/furniture/Lux L-Recliner.jpeg', category: 'Recliners', rating: 4.7, reviews: 112, features: ['L-Shape', 'Reclining', 'Spacious'], isSale: true },
    { id: 29, name: 'Luxury Recliner Chair', price: '', originalPrice: '', image: '/images/furniture/Luxury recliner chair.png', category: 'Recliners', rating: 4.8, reviews: 128, features: ['Luxury', 'Comfortable', 'Elegant'], isSale: true },
    { id: 44, name: 'Accent Recliner', price: '', originalPrice: '', image: '/images/furniture/Accent Recliner.png', category: 'Recliners', rating: 4.7, reviews: 55, features: ['Accent Design', 'Compact', 'Comfortable'], isNew: true, isSale: false },
    { id: 45, name: 'Elite-pro Recliner', price: '', originalPrice: '', image: '/images/furniture/Elite-pro Recliner.png', category: 'Recliners', rating: 4.8, reviews: 61, features: ['Elite Pro', 'Premium Comfort', 'Modern Look'], isNew: true, isSale: false },
    { id: 46, name: 'Home Theatre Recliner', price: '', originalPrice: '', image: '/images/furniture/Home theatre Recliner.png', category: 'Recliners', rating: 4.9, reviews: 73, features: ['Home Theatre', 'Cup Holders', 'Reclining'], isNew: true, isSale: true },
    { id: 47, name: 'Verona Comfort Recliner', price: '', originalPrice: '', image: '/images/furniture/Verona comfort Recliner.png', category: 'Recliners', rating: 4.8, reviews: 59, features: ['Verona Comfort', 'Elegant', 'Supportive'], isNew: true, isSale: false },
    { id: 48, name: 'Zen Comfort Recliner', price: '', originalPrice: '', image: '/images/furniture/Zen comfort Recliner.png', category: 'Recliners', rating: 4.7, reviews: 48, features: ['Zen Comfort', 'Relaxing', 'Soft Upholstery'], isNew: true, isSale: false },
    { id: 69, name: 'Fair Recliners', price: '', originalPrice: '', image: '/images/furniture/Fair Recliners.avif', category: 'Recliners', rating: 4.6, reviews: 35, features: ['Fair Price', 'Quality', 'Comfortable'], isNew: true, isSale: false },
    { id: 70, name: 'Couch Sofa Recliner', price: '', originalPrice: '', image: '/images/furniture/Couch Sofa Recliner.webp', category: 'Recliners', rating: 4.8, reviews: 68, features: ['Reclining', 'Modern Design', 'Comfort'], isNew: true, isSale: false },

    // Chairs
    { id: 30, name: 'Designer Armchair', price: '', originalPrice: '', image: '/images/furniture/Designer Armchair.png', category: 'Chairs', rating: 4.8, reviews: 98, features: ['Designer', 'Comfortable', 'Elegant'], isNew: true, isSale: true },
    { id: 31, name: 'Accent Chairs', price: '', originalPrice: '', image: '/images/furniture/Accent chairs.jpeg', category: 'Chairs', rating: 4.6, reviews: 87, features: ['Accent', 'Stylish', 'Compact'], isSale: true },
    { id: 32, name: 'Barrel Accent Chair', price: '', originalPrice: '', image: '/images/furniture/Barrel accent chair.jpeg', category: 'Chairs', rating: 4.7, reviews: 76, features: ['Barrel Design', 'Unique', 'Comfortable'], isSale: true },
    { id: 33, name: 'Premium Lounge Chair', price: '', originalPrice: '', image: '/images/furniture/Premium lounge chair.jpeg', category: 'Chairs', rating: 4.9, reviews: 134, features: ['Lounge', 'Premium', 'Relaxing'], isNew: true, isSale: true },
    { id: 34, name: 'Scallop Lounge Chair', price: '', originalPrice: '', image: '/images/furniture/Scallop lounge chair.png', category: 'Chairs', rating: 4.7, reviews: 89, features: ['Scallop Design', 'Elegant', 'Comfortable'], isSale: true },
    { id: 35, name: 'Single Lounge Chair', price: '', originalPrice: '', image: '/images/furniture/single lounge chair.jpeg', category: 'Chairs', rating: 4.8, reviews: 92, features: ['Single', 'Lounge', 'Comfortable'], isSale: true },
    { id: 67, name: 'Relax Lounge Chair', price: '', originalPrice: '', image: '/images/furniture/Relax lounge Chair.jpg', category: 'Chairs', rating: 4.7, reviews: 40, features: ['Lounge', 'Relaxing', 'Comfortable'], isNew: true, isSale: false },
    { id: 49, name: 'Lounge Chair', price: '', originalPrice: '', image: '/images/furniture/Lounge chair.png', category: 'Chairs', rating: 4.6, reviews: 44, features: ['Comfortable', 'Modern', 'Compact'], isNew: true, isSale: false },
    { id: 50, name: 'Mono Luxe Arm Chair', price: '', originalPrice: '', image: '/images/furniture/Mono luxe arm chair.jpg', category: 'Chairs', rating: 4.7, reviews: 51, features: ['Arm Support', 'Luxe Finish', 'Durable'], isNew: true, isSale: false },
    { id: 51, name: 'Nordic Comfort Chair', price: '', originalPrice: '', image: '/images/furniture/Nordic comfort chair.jpg', category: 'Chairs', rating: 4.6, reviews: 37, features: ['Nordic Style', 'Ergonomic', 'Lightweight'], isNew: true, isSale: false },
    { id: 52, name: 'Softnest Single Seater', price: '', originalPrice: '', image: '/images/furniture/Softnest single seater.jpg', category: 'Chairs', rating: 4.5, reviews: 29, features: ['Soft Cushion', 'Single Seater', 'Cozy'], isNew: true, isSale: false },
    { id: 53, name: 'Urban Lounge Chair', price: '', originalPrice: '', image: '/images/furniture/Urban lounge Chair.jpg', category: 'Chairs', rating: 4.7, reviews: 60, features: ['Urban Design', 'Stylish', 'Comfort'], isNew: true, isSale: true },

    // Wall Padding
    { id: 36, name: '3D Padded Wall', price: '', originalPrice: '', image: '/images/furniture/3D padded wall.jpeg', category: 'Wall Padding', rating: 4.9, reviews: 156, features: ['3D Design', 'Soundproof', 'Premium'], isNew: true, isSale: true },
    { id: 55, name: 'Aura Premium Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Aura-premium Wall padding.png', category: 'Wall Padding', rating: 4.8, reviews: 67, features: ['Premium', 'Elegant', 'Durable'], isNew: true, isSale: false },
    { id: 56, name: 'Contemporary Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Contemporary Wall Padding.jpg', category: 'Wall Padding', rating: 4.6, reviews: 41, features: ['Contemporary', 'Modern', 'Sleek'], isNew: true, isSale: false },
    { id: 57, name: 'Designer Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Designer Wall Padding.jpg', category: 'Wall Padding', rating: 4.8, reviews: 58, features: ['Designer', 'Luxury', 'Stylish'], isNew: true, isSale: false },
    { id: 58, name: 'Elegance Fabric Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Elegance fabric Wall Padding.png', category: 'Wall Padding', rating: 4.7, reviews: 49, features: ['Fabric', 'Elegant', 'Premium'], isNew: true, isSale: false },
    { id: 59, name: 'Elite 3D Padded Wall', price: '', originalPrice: '', image: '/images/furniture/Elite-3d-padded-wall.png', category: 'Wall Padding', rating: 4.9, reviews: 71, features: ['Elite', '3D Design', 'Premium'], isNew: true, isSale: true },
    { id: 60, name: 'Home Sectional Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Home-sectional Wall padding.png', category: 'Wall Padding', rating: 4.6, reviews: 36, features: ['Sectional', 'Modern', 'Comfortable'], isNew: true, isSale: false },
    { id: 61, name: 'Luxury Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Luxury Wall Padding.jpg', category: 'Wall Padding', rating: 4.8, reviews: 63, features: ['Luxury', 'Premium', 'Elegant'], isNew: true, isSale: false },
    { id: 62, name: 'Regal Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Regal Wall Padding.jpg', category: 'Wall Padding', rating: 4.7, reviews: 45, features: ['Regal', 'Sophisticated', 'Premium'], isNew: true, isSale: false },
    { id: 63, name: 'Royal Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Royal Wall Padding.png', category: 'Wall Padding', rating: 4.9, reviews: 69, features: ['Royal Design', 'Luxurious', 'Elegant'], isNew: true, isSale: true },
    { id: 64, name: 'Urban Geo Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Urban geo wall Padding.jpg', category: 'Wall Padding', rating: 4.6, reviews: 38, features: ['Urban', 'Geometric', 'Modern'], isNew: true, isSale: false },
    { id: 65, name: 'Urban Wall Padding', price: '', originalPrice: '', image: '/images/furniture/Urban Wall Padding.png', category: 'Wall Padding', rating: 4.7, reviews: 51, features: ['Urban', 'Trendy', 'Contemporary'], isNew: true, isSale: false },
  ];

  const filteredProducts = selectedCategory === 0
    ? products
    : products.filter(product => product.category === categories[selectedCategory].name);

  const displayedProducts = showAll ? filteredProducts : filteredProducts.slice(0, 9);



  return (
    <Box id="products" sx={{ py: { xs: 4, md: 8 }, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              mb: 2,
              color: '#8B7355',
              fontWeight: 'bold',
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Manufacturer Direct - 50% OFF
          </Typography>

          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              mb: { xs: 3, md: 6 },
              color: 'text.secondary',
              maxWidth: 700,
              mx: 'auto',
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' },
              px: { xs: 1, sm: 2 },
            }}
          >
            Premium quality sofas at wholesale prices. Bulk orders welcome for IKEA, retailers & individuals.
            All designs customizable. Delivery across India.
          </Typography>
        </motion.div>

        {/* Category Buttons */}
        <Box sx={{ mb: { xs: 3, md: 4 }, px: { xs: 2, sm: 3 } }}>
          <Box sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}>
            {categories.map((category, index) => (
              <Button
                key={index}
                variant={selectedCategory === index ? 'contained' : 'outlined'}
                onClick={() => setSelectedCategory(index)}
                startIcon={
                  <span
                    style={{
                      fontSize: '1.2rem',
                      background: selectedCategory === index ? 'rgba(255,255,255,0.2)' : '#8B7355',
                      borderRadius: '50%',
                      padding: '4px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {category.icon}
                  </span>
                }
                sx={{
                  textTransform: 'none',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  fontWeight: 600,
                  px: { xs: 2, sm: 3 },
                  py: 1.5,
                  borderRadius: 3,
                  color: selectedCategory === index ? 'white' : '#8B7355',
                  borderColor: '#8B7355',
                  backgroundColor: selectedCategory === index ? '#8B7355' : 'transparent',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 2,
                    backgroundColor: selectedCategory === index ? '#8B7355' : 'rgba(139,115,85,0.1)',
                    color: selectedCategory === index ? 'white' : '#8B7355',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                {category.name}
              </Button>
            ))}
          </Box>
        </Box>

        {/* Products Grid */}
        <div className="products-grid">
          {displayedProducts.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="product-card">
                <Box sx={{ position: 'absolute', top: 12, left: 12, zIndex: 1 }}>
                  {product.isNew && (
                    <Chip
                      label="New"
                      size="small"
                      sx={{
                        backgroundColor: '#8B7355',
                        color: 'white',
                        mr: 1,
                        mb: 1,
                      }}
                    />
                  )}
                  {product.isSale && (
                    <Chip
                      label="Sale"
                      size="small"
                      sx={{
                        backgroundColor: '#8B7355',
                        color: 'white',
                      }}
                    />
                  )}
                </Box>

                <CardMedia
                  component="img"
                  image={product.image}
                  alt={product.name}
                  sx={{
                    height: { xs: 180, sm: 220, md: 250 },
                    objectFit: 'cover',
                    objectPosition: 'center',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    },
                  }}
                />

                <Box sx={{ p: { xs: 2, sm: 2.5, md: 3 }, flexGrow: 1, textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' }, textAlign: 'center', color: '#5C4A3D' }}>
                    {product.name}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: { xs: '0.8rem', sm: '0.875rem' }, textAlign: 'center' }}>
                    {product.features.join(' • ')}
                  </Typography>

                  <Button
                    variant="contained"
                    fullWidth
                    href={`https://wa.me/916309561983?text=Hello!%20I'm%20interested%20in%20the%20*${encodeURIComponent(product.name)}*.%20Please%20share%20more%20details%20and%20pricing.`}
                    target="_blank"
                    className="btn-hover"
                    sx={{
                      py: { xs: 1.2, sm: 1.5 },
                      fontWeight: 'bold',
                      textTransform: 'none',
                      fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' },
                      backgroundColor: '#8B7355',
                      '&:hover': {
                        backgroundColor: 'rgba(139,115,85,0.9)',
                      },
                    }}
                  >
                    Order on WhatsApp
                  </Button>
                </Box>
              </div>
            </motion.div>
          ))}
        </div>

        {/* View More Button */}
        {filteredProducts.length > 9 && (
          <Box sx={{ textAlign: 'center', mt: { xs: 4, md: 6 } }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => setShowAll(!showAll)}
              className="btn-hover"
              sx={{
                px: { xs: 3, sm: 4 },
                py: { xs: 1.2, sm: 1.5 },
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                textTransform: 'none',
                color: '#8B7355',
                borderColor: '#8B7355',
              }}
            >
              {showAll ? 'Show Less' : `View All Products (${filteredProducts.length})`}
            </Button>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Products;





